import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import classNames from "classnames";
import { Button } from "@/components/Button";
import sendolaPay from "@/assets/Img/logo-sendola-pay.png";
import sendolaPayWhite from "@/assets/Img/logo-sendola-pay-white.png";

const AuthUrl = import.meta.env.VITE_AUTH_DOMAIN;

export const Header = () => {
  const [t] = useTranslation("global");
  const [verticalScrolled, setVerticalScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const checkVerticalScroll = () => {
      const scrollY = window.scrollY;
      setVerticalScrolled(scrollY > 30);
    };

    window.addEventListener("scroll", checkVerticalScroll);

    return () => {
      window.removeEventListener("scroll", checkVerticalScroll);
    };
  }, []);

  return (
    <>
      <nav className="z-[100] sticky top-0 transition-all duration-200 ease-in">
        <div
          className={classNames(
            "w-full flex justify-between items-center transition-all",
            {
              "bg-gray-950/80": verticalScrolled,
              "bg-lightblue":
                !verticalScrolled &&
                (location.pathname === "/" || location.pathname === ""),
              "h-16 px-4 py-2": true, // Mobile styles
              "lg:px-8 lg:h-20": true, // Desktop styles
            }
          )}
        >
          <div className="flex gap-4 md:gap-10 items-center flex-shrink-0">
            <Link to="/">
              {verticalScrolled ? (
                <img
                  className="h-9 sm:h-10 md:h-12 xl:h-14 w-auto object-contain select-none"
                  src={sendolaPayWhite}
                  alt="SendolaPay Personal Logo"
                />
              ) : (
                <img
                  className="h-9 sm:h-10 md:h-12 xl:h-14 w-auto object-contain select-none"
                  src={sendolaPay}
                  alt="SendolaPay Personal Logo"
                />
              )}
            </Link>
          </div>

          <div className="relative h-full flex items-center gap-4">
            <div className="flex gap-2">
              {/* <Button
                className="bg-primary-500 !text-white !border-0 !px-8 hover:bg-primary-400"
                size="sm"
                text={t("Header.LoginButton")}
                link={`${AuthUrl}/sign-in`}
              />
              <Button
                className="bg-white !border-0 !px-8 text-primary-500 hover:bg-gray-200"
                variant="secondary"
                size="sm"
                text={t("Header.SignupButton")}
                link={`${AuthUrl}/sign-up`}
              /> */}
              <Button
                className="bg-primary-500 !border-0 !px-8"
                size="sm"
                text={t("Header.SignupButton")}
                link={`${AuthUrl}/sign-up?source=finabien`}
              />
            </div>
          </div>
        </div>
      </nav>
    </>
  );
};
